import { toast } from 'react-toastify';

export const submitHelper = (e, formik, t) => {
  e.preventDefault();

  console.log({ errors: formik?.errors, values: formik?.values });

  if (formik.isValid) {
    formik.handleSubmit();
  } else {
    formik.setTouched({
      ...formik.errors,
    });

    setTimeout(() => {
      const errorField = document.querySelector('.error-field');
      if (errorField) {
        const previousSibling = errorField.previousElementSibling;
        if (previousSibling) {
          previousSibling.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, 500);

    toast.error(t('schoolRegistrationForm.error'));
  }
};

export const scrollToClass = (id) => {
  setTimeout(() => {
    window.scrollTo({
      top: document.getElementById(id).offsetTop - 20,
      behavior: 'smooth',
    });
  }, 200);
};
